//
// Module for participant Status index
//
rs.module("content/participant/about/status/index",

    [
        "common/select-helper"
    ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, lrsGridApi) {
            var participantStatusView = $.js(jsSelectors.participantStatusView);

            var newStatusForm = participantStatusView.js(jsSelectors.newStatusForm, { required: false });
            var newStatusSelect, basisPlanSelect, basisPlanSelectHelper, cancelServiceCreditCheckbox;
            if (newStatusForm.length > 0) {
                newStatusSelect = newStatusForm.js(jsSelectors.newStatusSelect);
                basisPlanSelect = newStatusForm.js(jsSelectors.basisPlanSelect);
                basisPlanSelectHelper = selectHelper.getHelper(basisPlanSelect);
                cancelServiceCreditCheckbox = newStatusForm.js(jsSelectors.cancelServiceCreditCheckbox, { required: false });
            }

            var statusHistoryForm = participantStatusView.js(jsSelectors.statusHistoryForm);
            var addStatusHistoryLink = statusHistoryForm.js(jsSelectors.addStatusHistoryLink, { required: false });
            var saveStatusHistoryButton = statusHistoryForm.js(jsSelectors.saveStatusHistoryButton, { required: false });

            // On Status select change, toggle appropriate fields based on selection
            if (newStatusSelect) {
                newStatusSelect.change(function () {
                    if (this.value != codeValues.deferred) {
                        basisPlanSelectHelper.setValue(null);
                        basisPlanSelect.clearErrors()
                    }

                    basisPlanSelectHelper.setDisabled(this.value != codeValues.deferred);

                    if (cancelServiceCreditCheckbox.length > 0) {
                        if (this.value != codeValues.terminated) {
                            cancelServiceCreditCheckbox.prop('checked', false);
                        }

                        cancelServiceCreditCheckbox.prop('disabled', this.value != codeValues.terminated);
                    }
                });
            }

            // Hook up a grid's Add link click
            addStatusHistoryLink.click(function () {
                lrsGridApi.addRow();
            });

            // enable save of history if there are pending changes
            lrsGridApi.rowChanged(function (change) {
                saveStatusHistoryButton.setDisabled(lrsGridApi.agGridApi.getDisplayedRowCount() === 0);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);